function d() {
  let r;
  return { before({ doc: e }) {
    var l;
    let o = e.documentElement, t = (l = e.defaultView) != null ? l : window;
    r = Math.max(0, t.innerWidth - o.clientWidth);
  }, after({ doc: e, d: o }) {
    let t = e.documentElement, l = Math.max(0, t.clientWidth - t.offsetWidth), n = Math.max(0, r - l);
    o.style(t, "paddingRight", `${n}px`);
  } };
}
export {
  d as adjustScrollbarPadding
};
